import axios from "axios";
import { BACKEND_URL } from "../../../utils/api";
import { TransactionTracking } from "../utils/database";

export const transactionTrackingService = {
  async getAll(
    token: string,
    params?: { skip?: number; limit?: number; status?: string; search?: string }
  ): Promise<{ items: TransactionTracking[]; total: number }> {
    try {
      const response = await axios.get(`${BACKEND_URL}/transaction-tracking/`, {
        headers: { Authorization: `Bearer ${token}` },
        params,
      });
      return {
        items: response.data.data.items || [],
        total: response.data.data.total || 0,
      };
    } catch (error) {
      console.error(error);
      throw error;
    }
  },

  async getById(token: string, id: number): Promise<TransactionTracking> {
    const response = await axios.get(`${BACKEND_URL}/transaction-tracking/${id}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data.data.item;
  },

  async create(token: string, data: Partial<TransactionTracking>): Promise<TransactionTracking> {
    const response = await axios.post(`${BACKEND_URL}/transaction-tracking/`, data, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data.data.item;
  },

  async update(token: string, id: number, data: Partial<TransactionTracking>): Promise<TransactionTracking> {
    const response = await axios.put(`${BACKEND_URL}/transaction-tracking/${id}`, data, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data.data.item;
  },

  async delete(token: string, id: number): Promise<void> {
    await axios.delete(`${BACKEND_URL}/transaction-tracking/${id}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
  },

  async getStats(token: string): Promise<{ total: number; status_counts: Record<string, number> }> {
    const response = await axios.get(`${BACKEND_URL}/transaction-tracking/stats/summary`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data.data;
  },
};
